import { render } from "./JoinPublicationEmail.vue.js?vue&type=template&id=2eb6950a!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=template&id=2eb6950a"
import script from "./JoinPublicationEmail.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=script&lang=js"
export * from "./JoinPublicationEmail.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eb6950a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eb6950a', __exports__)) {
    api.reload('2eb6950a', __exports__)
  }
  
  module.hot.accept("./JoinPublicationEmail.vue.js?vue&type=template&id=2eb6950a!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=template&id=2eb6950a", () => {
    api.rerender('2eb6950a', render)
  })

}


export default __exports__